import React, { useEffect } from 'react'
import Form from 'react-bootstrap/Form';
import { Link, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import loginimg from '../Assets/Images/forget.png';
import logo from '../Assets/Images/Caduceus 512x512.gif';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-toastify'
import { BASE_URL, FORGOT_PASSWORD } from '../API';

function ForgetPassword() {

  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const navigate = useNavigate();

  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    setValue('email', storedEmail);
  }, [])

  const onSubmit = async (data) => {
    data.language = "ENGLISH"
    try {
      const response = await axios.post(BASE_URL + FORGOT_PASSWORD, data)
      toast.success(response?.data?.message)
      // navigate('/email-sent-confrimation')
      navigate('/email-sent-confrimation', { state: { email: data.email } });

    }
    catch (error) {
      let err = error.response.data.error_description;
      toast.error(err)
    }
  }

  return (
    <>
      <section className="login-section">
        <div className="container-fluid g-0">
          {/* <Header /> */}
          <Row className='row-min-h'>
            <Col lg={6} className='img-n'>
              <div className="upper-fig-main-login">
                <figure className='login-img-main'>
                  <img src={loginimg} alt="" />
                </figure>
              </div>
            </Col>
            <Col lg={6}>
              <div className="inner-login-mian">
                <div className="loginupper-right forgot">
                  <figure className='creden_page_logo'>
                    <img src={logo} alt="" className='img-fluid' />
                  </figure>
                  <h2>Forgot Your Password?</h2>
                  <p className='auth_page_sub_heading'>Enter your email and we will send you the link on your email you can reset your password there.</p>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={12}>
                        <Form.Group controlId="formGridEmail" className='comn-class-inputs mb-0'>
                          <Form.Label>email</Form.Label>
                          <Form.Control type="email" placeholder="Enter Your Email" autoFocus {...register('email', {
                            required: 'Please enter email.',
                            pattern: {
                              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                              message: "Please enter valid email."
                            }
                          })} />
                          {errors.email && <span className='error'>{errors.email.message}</span>}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Button className='login-btn' type="submit">
                      Send
                    </Button>
                    <div className="auth-bottom-link-sec">
                      <p>Back to <Link to="/"> Login</Link></p>
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  )
}

export default ForgetPassword